import React from 'react';
import SEO from '../components/SEO';
import Content from '../components/Content';
import Gallery from '../components/Gallery';

const About = () => {
  return (
    <>
      <SEO
        title="About Perumal Crane Services | Expert Crane Rental in Coimbatore"
        description="Learn about Perumal Crane Services - Coimbatore's trusted crane rental company. We offer professional crane services with 10-200 ton capacity, expert operators, and 24/7 support. View our work gallery and service capabilities."
        keywords="about Perumal Crane Services, crane rental company Coimbatore, professional crane operators, crane service capabilities, heavy lifting equipment, construction crane experts, industrial crane solutions"
        canonicalUrl="/about"
        ogTitle="About Perumal Crane Services - Professional Crane Rental Experts"
        ogDescription="Discover why Perumal Crane Services is Coimbatore's leading crane rental provider. Expert team, advanced equipment, and commitment to safety."
      />
      <Content />
      <Gallery />
    </>
  );
};

export default About;